import React from 'react';

import {
  MdAdd,
  MdSearch,
  MdOutlineFilterList,
  MdArrowDownward,
} from 'react-icons/md';

import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import FormGroup from '@mui/material/FormGroup';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import PayablesDropDown from '../../../ConstructionsDetails/payables/PayableDropDown/PayablesDropDown';

import {
  MOCK_HEADER_INFO,
  PAYABLES_MOCK,
} from '../../../../../../../services/driverJS/mocks';

import {
  BtnSecondaryStyled,
  BtnStyled,
  RootStyled,
  MiddleOfThePageStyled,
  AttachmentStyled,
  ButtonInputStyled,
  FilterButtonStyled,
  IconContentStyled,
  SearchAndFilterStyled,
  SearchStyled,
  SwitchStyled,
  TableCellBodyStyled,
  TableCellHeaderStyled,
  TableRowStyled,
  TableStyled,
  TextFieldStyled,
  TotalAmountStyled,
} from './index.styles';

const headings = [
  'Vencimento',
  'Fornecedor',
  'Descrição',
  'Item',
  'Valor',
  'Status',
  'Lançamento',
  'Anexos',
  'Duplicar',
];

export function TourPayables() {
  const user = JSON.parse(localStorage.getItem('user'));

  return (
    <Paper style={{ paddingBottom: '32px' }}>
      <RootStyled>
        <Typography
          id="construction-name"
          style={{ fontSize: '24px' }}
          variant="h1"
        >
          Obra Tour
        </Typography>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <div style={{ marginTop: 8 }} id="budget-box">
            <PayablesDropDown headerInfo={MOCK_HEADER_INFO} />
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: 16,
            }}
          >
            <BtnStyled id="export-button" variant="outlined">
              Exportar lançamento
            </BtnStyled>
            <BtnSecondaryStyled id="new-payable-button" variant="contained">
              <MdAdd />
              <Typography variant="button">Novo lançamento</Typography>
            </BtnSecondaryStyled>
          </div>
        </div>
        <div>
          <MiddleOfThePageStyled>
            <Typography
              style={{
                fontSize: '18px',
                lineHeight: '19px',
                fontWeight: 500,
              }}
              variant="h2"
              id="payables-total"
            >
              Lançamentos: 3
            </Typography>

            <SearchAndFilterStyled>
              <SearchStyled id="search">
                <TextFieldStyled type="search" />
                <ButtonInputStyled variant="contained">
                  <MdSearch size={17} />
                </ButtonInputStyled>
              </SearchStyled>
              <FilterButtonStyled id="filter-icon" size="large">
                <MdOutlineFilterList size={33} />
              </FilterButtonStyled>
            </SearchAndFilterStyled>
          </MiddleOfThePageStyled>
        </div>
        <Paper>
          <TableStyled id="home-view">
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  {headings.map((label) => {
                    const headersWidth = {
                      Vencimento: '10%',
                      Fornecedor: '20%',
                      Descrição: '25%',
                      Obra: '15%',
                      Item: '6%',
                      Valor: '8%',
                      Status: '6%',
                      Lançamento: '6%',
                      Anexos: '6%',
                      Duplicar: '3%',
                    };

                    const columnsIds = {
                      Vencimento: 'due-column',
                      Fornecedor: 'supplier-column',
                      Descrição: 'description-column',
                      Obra: 'construction-column',
                      Item: 'item-column',
                      Valor: 'value-column',
                      Status: 'status-column',
                      Lançamento: 'date-column',
                      Anexos: 'attachments-column',
                      Duplicar: 'duplicate-column',
                    };

                    return (
                      <TableCellHeaderStyled
                        key={label}
                        style={{ width: headersWidth[label] }}
                        id={columnsIds[label]}
                      >
                        <div
                          style={{
                            cursor:
                              label === 'Duplicar' ? 'default' : 'pointer',
                          }}
                        >
                          {label}{' '}
                          {label === 'Vencimento' && (
                            <MdArrowDownward size={18} />
                          )}
                        </div>
                      </TableCellHeaderStyled>
                    );
                  })}
                </TableRow>
              </TableHead>
              <TableBody>
                {PAYABLES_MOCK.map((data) => (
                  <TableRowStyled key={data.id}>
                    <TableCellBodyStyled style={{ textAlign: 'center' }}>
                      {data.due}
                    </TableCellBodyStyled>
                    <TableCellBodyStyled>
                      {data.supplier.name}
                    </TableCellBodyStyled>
                    <TableCellBodyStyled>
                      {data.description}
                    </TableCellBodyStyled>
                    <TableCellBodyStyled style={{ textAlign: 'center' }}>
                      {data.payable_items.length}
                    </TableCellBodyStyled>
                    <TableCellBodyStyled>{data.total}</TableCellBodyStyled>
                    <TableCell>
                      <FormGroup aria-owns="mouse-over-popover">
                        <Tooltip
                          title={data.status_id === 0 ? 'Pendente' : 'Pago'}
                        >
                          <SwitchStyled
                            checked={data.status_id !== 0}
                            inputProps={{ 'aria-label': 'Switch A' }}
                          />
                        </Tooltip>
                      </FormGroup>
                    </TableCell>
                    <TableCellBodyStyled style={{ textAlign: 'center' }}>
                      {data.created_at}
                    </TableCellBodyStyled>
                    <TableCell>
                      <AttachmentStyled>
                        {data.total_attachments}
                      </AttachmentStyled>
                    </TableCell>
                    {user.user_type !== 'client' && (
                      <TableCellBodyStyled>
                        <IconButton size="large">
                          <IconContentStyled size={24} />
                        </IconButton>
                      </TableCellBodyStyled>
                    )}
                  </TableRowStyled>
                ))}
              </TableBody>
            </Table>
          </TableStyled>
          <TotalAmountStyled>
            <Typography variant="h3">VALOR TOTAL</Typography>
            <Typography variant="h3">
              {new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL',
              }).format(1055)}
            </Typography>
          </TotalAmountStyled>
        </Paper>
      </RootStyled>
    </Paper>
  );
}
